/* Copyright (c) Trimble Inc. All rights reserved. */

import { EnvironmentConfig } from '../types/environment.model';

export const environment: EnvironmentConfig = {
  auth: {
    clientId: '29ed2ad1-68a6-441f-a922-2f4c57e9dca1',
    environment: 'STAGING',
    scopes: ['openid', 'developerconsole', 'iam', 'iam-devtest', 'connect'],
  },
  iamRoles: [
    {
      id: ['0ded1d21-f269-466b-b04d-cd08cb2d4082'],
      name: 'Administrator',
    },
    {
      id: ['f427aae6-bd84-432b-8858-7301e2f44b46'],
      name: 'Developer',
    },
  ],
  emailTemplates: {
    joinTeamApprove: {
      templateId: '9d9e71fd68fe40ff8fdab55fd070b10b',
    },
    joinTeamReject: {
      templateId: '61621a4d9eab4fd9bc86347e9a498d3e',
    },
    acceptTeamInviteAdminNotification: {
      templateId: 'da0c3d29fbd844e28ab816ed839fa653',
    },
    rejectTeamInviteAdminNotification: {
      templateId: '07a8505c959b44ccb6d265f1f0a7e0f4',
    },
    selfJoinTeam: {
      templateId: '71aaeced005a4972a57b30eecfa20b6c',
      variables: {
        review_url: 'https://console.stage.developer.trimblecloud.com/home/notifications',
      },
    },
    changeRole: {
      templateId: '4a217d59a6364dd3beec299796062971',
    },

    addMemberExistingConsoleUser: {
      templateId: '5b0fdb8437724900b0ecd832a1db3b39',
    },
    addMemberExistingTidUser: {
      templateId: '4c949c04d0574b6db72a4190b5250810',
    },
    addMemberNewTidUser: {
      templateId: 'a84b748cfcbc49caacfd354cbb9dfc32',
    },
    removeExistingMemberFromTeam: {
      adminTemplateId: '5fe08d635d1143e09cb316a04ab48adb',
      userTemplateId: '5fa9e021ffd44a4ab35dcbeb1e0c5b52',
    },
  },
  environment: 'STAGING',
  GuestRoleID: '09a79c4d-1faf-4fac-9237-eb12679a07a0',
  applicationAuthorizationPermissionId: 'a58ccf88-60d1-4457-85e0-dfc98fa9f550',
  adminConsoleBaseURL: 'https://stage.accounts.trimble.com',
  clients: [
    {
      name: 'apicloud',
      baseUrl: 'https://developer-console.stage.api.trimblecloud.com',
    },
    {
      name: 'iam',
      baseUrl: 'https://developer-console.stage.api.trimblecloud.com/iam',
    },
    {
      name: 'validation',
      baseUrl: 'https://cloud.stage.api.trimblecloud.com/business-systems/validation-api/1.0',
    },
  ],
  featureFlags: {
    enableMarketplaceIntegration: true,
    enableDxIntegration: true,
    enableApplicationExtension: true,
    enableSandbox: true,
    enableInternalUserRedirect: true,
    enableMswMocking: false,
    enableMultiAccountAuthorization: true,
    enableApplicationAuthorization: true,
    enableTaxInformation: false,
  },
  application: {
    baseUrl: 'https://console.stage.developer.trimblecloud.com',
    internalConsoleBaseUrl: 'https://console.stage.api.trimblecloud.com/',
    name: 'Developer Console',
  },
  appDirect: {
    baseUrl: 'https://trimblesandbox1.byappdirect.com',
    publicMarketplaceBaseUrl: 'https://trimblesandbox1.byappdirect.com',
  },
  gainsight: {
    enabled: true,
    productKey: 'AP-SYGGVVGZCVPY-2-2',
  },
  accountOwnerRoleIds: {
    primary: 'b1bdb748-8e73-47c9-97e6-a8ed63fe294d',
    secondary: '5f6b679e-2866-41ae-8dfe-55ebc31281d0',
  },
};
